export default class Controller {
  static boot() {
    FW.store.loaded('menu', () => {
      FW.store.get('menu').boot();
      FW.trigger('booted');
    });
  }
}
